export enum RouteGroup {
    Dashboard = "Dashboard",
    Calendar = "Calendar",
    PrintableCalendar = "PrintableCalendar",
    Residents = "Residents",
    MediaLibrary = "MediaLibrary",
    ContentCreator = "ContentCreator",
    DigitalSignage = "DigitalSignage",
    LifestylePrograms = "LifestylePrograms",
    Concierge = "Concierge",
    Maintenance = "Maintenance",
    Surveys = "Surveys",
    Guestbook = "Guestbook",
    Reports = "Reports",
    Messaging = "Messaging",
    Gallery = "Gallery",
    Documents = "Documents"
}